import { Component } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class AppHeaderComponent {

  /** Signed-in address, for the account menu. Was a hardcoded "QA". */
  readonly email$: Observable<string | null>;

  /** The part before the @, used when the full address is too long for the bar. */
  readonly shortName$: Observable<string>;

  constructor(private router: Router, private auth: AuthService) {
    this.email$ = this.auth.email$;
    this.shortName$ = this.auth.email$.pipe(
      map(e => (e ? e.split('@')[0] : 'Account'))
    );
  }

  logout() {
    // Ends the Cognito session as well; clearing local tokens alone would sign straight back in
    // on the next redirect. Cognito returns the browser to the configured post-logout URL.
    this.auth.logout();
  }

  protected readonly environment = environment;
}
